export enum FollowUpCompleted {
  All = 'All',
  Yes = 'true',
  No = 'false',
}
